module.exports = __webpack_public_path__ + "img/cuqu.e51097a0.jpg";